/* eslint-disable @typescript-eslint/naming-convention */
import 'reflect-metadata';
import {FormElement, FormElementConfiguration} from 'app/entities/form/formElement.entity';
import {FormElementDateInputType, FormElementDateSelectView, FormElementDateTypes, FormElementType} from 'app/entities/enums';
import {Type} from 'class-transformer';

export class FormElementData extends FormElement {
  type: FormElementType = 'date';

  @Type(() => FormElementDateConfiguration)
  configuration?: FormElementDateConfiguration = new FormElementDateConfiguration();
}

export class FormElementDataRange extends FormElement {
  type: FormElementType = 'dateRange';

  @Type(() => FormElementDateConfiguration)
  configuration?: FormElementDateConfiguration = new FormElementDateConfiguration();
}

export class FormElementDateConfiguration extends FormElementConfiguration {
  format?: string = 'dd.MM.yyyy';
  type?: FormElementDateTypes = 'date';
  selectView?: FormElementDateSelectView = 'picker';
  minDate?: string = null;
  maxDate?: string = null;
  clearable= true;
  inputType?: FormElementDateInputType = 'date-time-together';
}
